export const errorTypeAction = {
    // ACCOUNT
    "ACCOUNT-001": {
        action : function () {
            window.location.href = '/logout';
        },
    },
    "ACCOUNT-002": {
        action : function () {
            window.location.href = '/logout';
        },
    },
    "ACCOUNT-003": {
        action : function () {
            window.location.href = '/dashboard';
        }
    },
    "AWS-002":{
        action: function () {
            window.location.reload();
        },
    }
}
